var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconSandTimerSvqdft6A9J(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e0f00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 401") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 46,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,48H4a1,1,0,0,1-1-1V44a4,4,0,0,1,4-4H41a4,4,0,0,1,4,4v3A1,1,0,0,1,44,48ZM5,46H43V44a2,2,0,0,0-2-2H7a2,2,0,0,0-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,25V23A13,13,0,0,0,39,10V8H9v2A13,13,0,0,0,22,23v2A15,15,0,0,1,7,10V7A1,1,0,0,1,8,6H40a1,1,0,0,1,1,1v3A15,15,0,0,1,26,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,42H8a1,1,0,0,1-1-1V38A15,15,0,0,1,22,23v2A13,13,0,0,0,9,38v2H39V38A13,13,0,0,0,26,25V23A15,15,0,0,1,41,38v3A1,1,0,0,1,40,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,8H7A4,4,0,0,1,3,4V1A1,1,0,0,1,4,0H44a1,1,0,0,1,1,1V4A4,4,0,0,1,41,8ZM5,2V4A2,2,0,0,0,7,6H41a2,2,0,0,0,2-2V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,19a1.15,1.15,0,0,1-.26,0l-15-4L9.26,13,24,17,38.74,13,39.26,15l-15,4A1.15,1.15,0,0,1,24,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.48,41.85,24,34.17,11.52,41.85l-1-1.7,13-8a1,1,0,0,1,1,0l13,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconSandTimerSvqdft6A9J);
export default __webpack_public_path__ + "static/media/reshot-icon-sand-timer-SVQDFT6A9J.384f7b274a7cad4d77b400b9c6cd0dce.svg";
export { ForwardRef as ReactComponent };